export default {
  NONE: 10000,
  COMMON: 10001,
  REMOVE_ASSET: 10002,
  CHANGE_NAME_ASSET: 10003,
};
